// Guided boxing / kickboxing workouts — intermediate, increasing difficulty.
// Each block: { kind: warmup|round|rest|drill|finisher|cooldown, name, seconds, cues[] }
// Text fields are bilingual { it, en }.

export const WORKOUTS = [
  {
    id: "foundation-flow",
    level: 1,
    color: "#10B981",
    minutes: 18,
    title: { it: "Foundation Flow", en: "Foundation Flow" },
    focus: { it: "Ritmo, guardia e footwork pulito", en: "Rhythm, guard and clean footwork" },
    blocks: [
      { kind: "warmup", seconds: 180, name: { it: "Riscaldamento", en: "Warm-up" }, cues: [
        { it: "Corda o saltelli sul posto, sciogli le spalle", en: "Jump rope or in-place bounces, loosen the shoulders" },
        { it: "Rotazioni di anche e collo, 20 jab a vuoto leggeri", en: "Hip & neck rotations, 20 light shadow jabs" } ] },
      { kind: "round", seconds: 180, name: { it: "Round 1 · Jab control", en: "Round 1 · Jab control" }, cues: [
        { it: "Jab singolo, torna sempre in guardia", en: "Single jab, always return to guard" },
        { it: "Jab–Cross lento e preciso, ruota l'anca", en: "Jab–Cross slow and precise, rotate the hip" },
        { it: "Muoviti di lato dopo ogni combo", en: "Step laterally after each combo" } ] },
      { kind: "rest", seconds: 45, name: { it: "Recupero", en: "Rest" }, cues: [
        { it: "Respira dal naso, mani alte", en: "Breathe through the nose, hands up" } ] },
      { kind: "round", seconds: 180, name: { it: "Round 2 · Aggiungi il gancio", en: "Round 2 · Add the hook" }, cues: [
        { it: "Jab–Cross–Gancio sinistro", en: "Jab–Cross–Lead hook" },
        { it: "Dopo la combo, slip laterale", en: "After the combo, lateral slip" } ] },
      { kind: "rest", seconds: 45, name: { it: "Recupero", en: "Rest" }, cues: [
        { it: "Rilassa le spalle, resta sulle punte", en: "Relax shoulders, stay on the balls of your feet" } ] },
      { kind: "round", seconds: 180, name: { it: "Round 3 · Doppio jab", en: "Round 3 · Double jab" }, cues: [
        { it: "Doppio Jab–Cross, entra nella distanza", en: "Double Jab–Cross, step into range" },
        { it: "Pivot dopo il cross per uscire d'angolo", en: "Pivot after the cross to exit the angle" } ] },
      { kind: "cooldown", seconds: 120, name: { it: "Defaticamento", en: "Cool-down" }, cues: [
        { it: "Stretching spalle, collo e polpacci", en: "Stretch shoulders, neck and calves" } ] },
    ],
  },
  {
    id: "power-pivots",
    level: 2,
    color: "#2563EB",
    minutes: 22,
    title: { it: "Power & Pivots", en: "Power & Pivots" },
    focus: { it: "Potenza di rotazione e colpi al corpo", en: "Rotational power and body shots" },
    blocks: [
      { kind: "warmup", seconds: 180, name: { it: "Riscaldamento", en: "Warm-up" }, cues: [
        { it: "Shadow leggero + 20 affondi con rotazione", en: "Light shadow + 20 lunges with rotation" } ] },
      { kind: "round", seconds: 180, name: { it: "Round 1 · Corpo-testa", en: "Round 1 · Body-head" }, cues: [
        { it: "Cross al corpo – Gancio alla testa", en: "Cross to body – Hook to head" },
        { it: "Piega le gambe, non la schiena", en: "Bend the knees, not the back" } ] },
      { kind: "rest", seconds: 45, name: { it: "Recupero", en: "Rest" }, cues: [ { it: "Idratati, mani alte", en: "Hydrate, hands up" } ] },
      { kind: "round", seconds: 180, name: { it: "Round 2 · Combo a 4", en: "Round 2 · 4-punch combo" }, cues: [
        { it: "Jab–Cross–Gancio sx–Cross", en: "Jab–Cross–Lead hook–Cross" },
        { it: "Ruota il tallone posteriore su ogni cross", en: "Rotate the rear heel on every cross" } ] },
      { kind: "rest", seconds: 45, name: { it: "Recupero", en: "Rest" }, cues: [ { it: "Respira e resta mobile", en: "Breathe and stay mobile" } ] },
      { kind: "drill", seconds: 120, name: { it: "Drill · Pivot d'angolo", en: "Drill · Angle pivot" }, cues: [
        { it: "Gancio sx → pivot 45° → cross", en: "Lead hook → 45° pivot → cross" },
        { it: "Alterna i lati, massima rotazione", en: "Alternate sides, max rotation" } ] },
      { kind: "round", seconds: 180, name: { it: "Round 3 · Pressione", en: "Round 3 · Pressure" }, cues: [
        { it: "Avanza con doppio jab, chiudi con gancio", en: "Advance with double jab, close with a hook" } ] },
      { kind: "finisher", seconds: 120, name: { it: "Finisher · Burpee+Shadow", en: "Finisher · Burpee+Shadow" }, cues: [
        { it: "5 burpee → 20s di colpi esplosivi, ripeti", en: "5 burpees → 20s explosive punches, repeat" } ] },
      { kind: "cooldown", seconds: 120, name: { it: "Defaticamento", en: "Cool-down" }, cues: [ { it: "Stretching e respirazione lenta", en: "Stretch and slow breathing" } ] },
    ],
  },
  {
    id: "kickboxing-engine",
    level: 3,
    color: "#F59E0B",
    minutes: 26,
    title: { it: "Kickboxing Engine", en: "Kickboxing Engine" },
    focus: { it: "Calci, teep e condizionamento specifico", en: "Kicks, teeps and sport-specific conditioning" },
    blocks: [
      { kind: "warmup", seconds: 180, name: { it: "Riscaldamento", en: "Warm-up" }, cues: [
        { it: "Mobilità anche + 20 calci bassi lenti per lato", en: "Hip mobility + 20 slow low kicks per side" } ] },
      { kind: "round", seconds: 180, name: { it: "Round 1 · Punch-kick", en: "Round 1 · Punch-kick" }, cues: [
        { it: "Jab–Cross–Low kick gamba posteriore", en: "Jab–Cross–Rear low kick" },
        { it: "Riporta subito la guardia dopo il calcio", en: "Recover the guard immediately after the kick" } ] },
      { kind: "rest", seconds: 45, name: { it: "Recupero", en: "Rest" }, cues: [ { it: "Respira, scuoti le gambe", en: "Breathe, shake out the legs" } ] },
      { kind: "round", seconds: 180, name: { it: "Round 2 · Teep & Switch", en: "Round 2 · Teep & Switch" }, cues: [
        { it: "Teep (spinta frontale) – Cross – Switch kick", en: "Teep (front push) – Cross – Switch kick" },
        { it: "Usa il teep per gestire la distanza", en: "Use the teep to manage distance" } ] },
      { kind: "rest", seconds: 45, name: { it: "Recupero", en: "Rest" }, cues: [ { it: "Mani alte, mento basso", en: "Hands up, chin down" } ] },
      { kind: "round", seconds: 180, name: { it: "Round 3 · Ginocchia", en: "Round 3 · Knees" }, cues: [
        { it: "Clinch immaginario: ginocchio dx – sx – gancio", en: "Imaginary clinch: knee right – left – hook" } ] },
      { kind: "drill", seconds: 120, name: { it: "Drill · Low kick power", en: "Drill · Low kick power" }, cues: [
        { it: "10 low kick potenti per gamba, tecnica piena", en: "10 powerful low kicks per leg, full technique" } ] },
      { kind: "finisher", seconds: 150, name: { it: "Finisher · Kick burnout", en: "Finisher · Kick burnout" }, cues: [
        { it: "30s calci continui – 15s plank, x3", en: "30s continuous kicks – 15s plank, x3" } ] },
      { kind: "cooldown", seconds: 120, name: { it: "Defaticamento", en: "Cool-down" }, cues: [ { it: "Stretching flessori dell'anca e quadricipiti", en: "Stretch hip flexors and quads" } ] },
    ],
  },
  {
    id: "speed-counters",
    level: 4,
    color: "#E63946",
    minutes: 30,
    title: { it: "Speed & Counters", en: "Speed & Counters" },
    focus: { it: "Difesa, contrattacchi e alta velocità", en: "Defense, counters and high speed" },
    blocks: [
      { kind: "warmup", seconds: 180, name: { it: "Riscaldamento", en: "Warm-up" }, cues: [
        { it: "Corda veloce + slip e rolling a vuoto", en: "Fast rope + shadow slips and rolls" } ] },
      { kind: "round", seconds: 180, name: { it: "Round 1 · Slip & counter", en: "Round 1 · Slip & counter" }, cues: [
        { it: "Slip esterno → Cross di rimessa", en: "Outside slip → counter Cross" },
        { it: "Minimo movimento di testa, massima reattività", en: "Minimal head movement, maximum reactivity" } ] },
      { kind: "rest", seconds: 40, name: { it: "Recupero", en: "Rest" }, cues: [ { it: "Respira, resta leggero", en: "Breathe, stay light" } ] },
      { kind: "round", seconds: 180, name: { it: "Round 2 · Check hook", en: "Round 2 · Check hook" }, cues: [
        { it: "Para il jab → Check hook in uscita", en: "Catch the jab → Check hook while exiting" } ] },
      { kind: "rest", seconds: 40, name: { it: "Recupero", en: "Rest" }, cues: [ { it: "Rilassa, mani alte", en: "Relax, hands up" } ] },
      { kind: "round", seconds: 180, name: { it: "Round 3 · Alta velocità", en: "Round 3 · High speed" }, cues: [
        { it: "Combo a 5 colpi al massimo ritmo", en: "5-punch combos at max pace" },
        { it: "Velocità prima della potenza", en: "Speed before power" } ] },
      { kind: "rest", seconds: 40, name: { it: "Recupero", en: "Rest" }, cues: [ { it: "Controlla il respiro", en: "Control your breathing" } ] },
      { kind: "round", seconds: 180, name: { it: "Round 4 · Counter kick", en: "Round 4 · Counter kick" }, cues: [
        { it: "Blocca il calcio → Low kick di rimessa", en: "Check the kick → counter low kick" } ] },
      { kind: "drill", seconds: 90, name: { it: "Drill · Mani veloci", en: "Drill · Fast hands" }, cues: [
        { it: "20s di pugni rapidi alla max frequenza, x2", en: "20s rapid punches at max cadence, x2" } ] },
      { kind: "finisher", seconds: 150, name: { it: "Finisher · Sprint & strike", en: "Finisher · Sprint & strike" }, cues: [
        { it: "20s sprint sul posto – 20s combo – 10s riposo, x3", en: "20s in-place sprint – 20s combo – 10s rest, x3" } ] },
      { kind: "cooldown", seconds: 120, name: { it: "Defaticamento", en: "Cool-down" }, cues: [ { it: "Respirazione, stretching completo", en: "Breathing, full-body stretch" } ] },
    ],
  },
  {
    id: "the-gauntlet",
    level: 5,
    color: "#8B5CF6",
    minutes: 35,
    title: { it: "The Gauntlet", en: "The Gauntlet" },
    focus: { it: "5 round completi + burnout finale", en: "5 full rounds + final burnout" },
    blocks: [
      { kind: "warmup", seconds: 200, name: { it: "Riscaldamento", en: "Warm-up" }, cues: [
        { it: "Corda + shadow progressivo, alza il ritmo", en: "Rope + progressive shadow, build the pace" } ] },
      { kind: "round", seconds: 180, name: { it: "Round 1 · Boxe", en: "Round 1 · Boxing" }, cues: [
        { it: "Combo a 3-4, pressione costante", en: "3-4 punch combos, constant pressure" } ] },
      { kind: "rest", seconds: 40, name: { it: "Recupero", en: "Rest" }, cues: [ { it: "Respira profondo", en: "Deep breaths" } ] },
      { kind: "round", seconds: 180, name: { it: "Round 2 · Boxe+Low kick", en: "Round 2 · Boxing+Low kick" }, cues: [
        { it: "Chiudi ogni combo con un low kick", en: "Close every combo with a low kick" } ] },
      { kind: "rest", seconds: 40, name: { it: "Recupero", en: "Rest" }, cues: [ { it: "Mani alte, resta mobile", en: "Hands up, stay mobile" } ] },
      { kind: "round", seconds: 180, name: { it: "Round 3 · Difesa-contrattacco", en: "Round 3 · Defense-counter" }, cues: [
        { it: "Slip/para → contrattacco a 3 colpi", en: "Slip/catch → 3-punch counter" } ] },
      { kind: "rest", seconds: 40, name: { it: "Recupero", en: "Rest" }, cues: [ { it: "Controlla il respiro", en: "Control your breathing" } ] },
      { kind: "round", seconds: 180, name: { it: "Round 4 · Clinch & ginocchia", en: "Round 4 · Clinch & knees" }, cues: [
        { it: "Ginocchia alternate + gomiti controllati", en: "Alternating knees + controlled elbows" } ] },
      { kind: "rest", seconds: 40, name: { it: "Recupero", en: "Rest" }, cues: [ { it: "Ultimo round in arrivo, carica", en: "Last round coming, load up" } ] },
      { kind: "round", seconds: 180, name: { it: "Round 5 · All-out", en: "Round 5 · All-out" }, cues: [
        { it: "Massimo volume: tutto quello che hai", en: "Max volume: everything you've got" } ] },
      { kind: "finisher", seconds: 180, name: { it: "Finisher · EMOM burnout", en: "Finisher · EMOM burnout" }, cues: [
        { it: "Ogni minuto: 10 burpee + 20 colpi, x3", en: "Every minute: 10 burpees + 20 punches, x3" } ] },
      { kind: "cooldown", seconds: 150, name: { it: "Defaticamento", en: "Cool-down" }, cues: [ { it: "Cammina, respira, stretching lungo", en: "Walk, breathe, long stretch" } ] },
    ],
  },
];

export const KIND_META = {
  warmup: { color: "#10B981", label: { it: "RISCALDAMENTO", en: "WARM-UP" } },
  round: { color: "#E63946", label: { it: "ROUND", en: "ROUND" } },
  rest: { color: "#2563EB", label: { it: "RECUPERO", en: "REST" } },
  drill: { color: "#F59E0B", label: { it: "DRILL", en: "DRILL" } },
  finisher: { color: "#8B5CF6", label: { it: "FINISHER", en: "FINISHER" } },
  cooldown: { color: "#6B7280", label: { it: "DEFATICAMENTO", en: "COOL-DOWN" } },
};

export const COMBO_LIBRARY = [
  "Jab – Cross", "Jab – Jab – Cross", "Jab – Cross – Lead Hook", "Cross – Lead Hook", "Jab – Cross – Slip",
  "Jab – Cross – Lead Hook – Cross", "Jab – Cross – Lead Uppercut – Rear Hook", "Double Jab – Cross – Low Kick",
  "Jab – Cross – Slip – Cross", "Lead Hook – Cross – Lead Hook", "Jab – Rear Low Kick – Cross",
  "Teep – Cross – Switch Kick", "Body Hook – Head Hook", "Knee – Knee – Hook",
  "Jab – Cross – Lead Hook – Rear Uppercut – Lead Hook", "Feint Jab – Cross – Lead Hook – Switch Kick",
  "Overhand – Lead Hook – Rear Low Kick – Cross", "Slip – Counter Cross", "Catch – Check Hook",
];

export const WEEKDAYS = [
  { key: "mon", it: "Lunedì", en: "Monday" },
  { key: "tue", it: "Martedì", en: "Tuesday" },
  { key: "wed", it: "Mercoledì", en: "Wednesday" },
  { key: "thu", it: "Giovedì", en: "Thursday" },
  { key: "fri", it: "Venerdì", en: "Friday" },
  { key: "sat", it: "Sabato", en: "Saturday" },
  { key: "sun", it: "Domenica", en: "Sunday" },
];

export const todayKey = () => WEEKDAYS[(new Date().getDay() + 6) % 7].key;

const both = (s) => ({ it: s, en: s });

export function customToWorkout(p) {
  const blocks = [];
  if (p.warmup_seconds) blocks.push({ kind: "warmup", seconds: p.warmup_seconds, name: { it: "Riscaldamento", en: "Warm-up" },
    cues: [{ it: "Corda o shadow leggero, sciogli spalle e anche", en: "Rope or light shadow, loosen shoulders and hips" }] });
  p.rounds.forEach((r, i) => {
    if (i > 0 && p.rest_seconds) blocks.push({ kind: "rest", seconds: p.rest_seconds, name: { it: "Recupero", en: "Rest" },
      cues: [{ it: "Respira dal naso, mani alte", en: "Breathe through the nose, hands up" }] });
    blocks.push({ kind: "round", seconds: r.seconds, name: { it: `Round ${i + 1}`, en: `Round ${i + 1}` },
      cues: r.combos.length ? r.combos.map(both) : [{ it: "Shadow libero, varia le combinazioni", en: "Free shadow, vary your combos" }] });
  });
  if (p.cooldown_seconds) blocks.push({ kind: "cooldown", seconds: p.cooldown_seconds, name: { it: "Defaticamento", en: "Cool-down" },
    cues: [{ it: "Stretching e respirazione lenta", en: "Stretch and slow breathing" }] });
  const total = blocks.reduce((a, b) => a + b.seconds, 0);
  return { id: `custom:${p.id}`, level: 0, custom: true, raw: p, color: "#E63946", minutes: Math.max(1, Math.round(total / 60)),
    title: both(p.name), focus: { it: "Programma personalizzato", en: "Custom program" }, blocks };
}

// Splits a block into timed steps so the player can show "now / next" and loop circuits.
export function segmentsOf(block) {
  const n = block.cues.length || 1;
  const circuit = block.kind === "round" || block.kind === "finisher";
  const loops = circuit && n > 1 ? Math.max(1, Math.round(block.seconds / (n * 45))) : 1;
  const count = block.kind === "rest" ? 1 : n * loops;
  return { count, loops, circuit: circuit && (n > 1 || loops > 1), segLen: block.seconds / count };
}
